/**
 * THE FIRST BROADCAST — fixture constants (kept dependency-free so menus can import them).
 *
 * Seed 176, 90 s halves: clear afternoon at Duncliffe Ground. Counter-attack → cross → first-time
 * shot inches wide (16.5 s) → goal kick → quiet spell → header, woodwork (42 s) → GOAL (45 s) →
 * long celebration. Check with `npm run sim -- --seed 176` (timings scale with half length).
 */
export const TRAINING_SEED = 176;
export const TRAINING_HALF_S = 90;
export const TRAINING_COMPETITION = 'Training — The First Broadcast';
